import Vue from 'vue';
import VueCodeHighlight from "vue-code-highlight";
import "prism-es6/components/prism-markup-templating";
import "prism-es6/components/prism-php";
import "vue-code-highlight/themes/prism.css";

Vue.use(VueCodeHighlight);

